<script lang="ts" setup>
interface Size {
  value: string;
  selectable: boolean;
}

withDefaults(
  defineProps<{
    sizes: Size[];
    selected?: string | undefined | null;
    sizeGuide?: boolean;
  }>(),
  {
    sizeGuide: false,
    selected: null,
  },
);

defineEmits(["change", "show-size-guide"]);

const { t } = useI18n();
</script>

<template>
  <div>
    <div class="flex items-center px-2.5">
      <h3 class="font-bold text-base lg:text-xl" :class="{ grow: selected }">
        {{ t("size") }}
      </h3>
      <span v-if="!selected" class="ml-2.5 grow text-base">{{
        t("choose_size")
      }}</span>
      <button
        v-if="sizeGuide"
        :aria-label="t('size_guide')"
        class="grow-0 shrink-0 font-light text-xs lg:text-base underline text-brand-link underline-offset-2"
        @click="$emit('show-size-guide')"
      >
        {{ t("size_guide") }}
      </button>
    </div>
    <div class="mt-4 xl:mt-3.5 px-3.5">
      <div>
        <BaseButton
          v-for="size in sizes"
          :key="size.value"
          type="plain"
          :disabled="!size.selectable"
          :title="!size.selectable ? t('out_of_stock') : ''"
          font-weight="normal"
          class="!bg-brand-secondary shadow-base mr-2 mb-2 xl:mr-2.5 xl:mb-2.5 min-w-[95px] min-h-[37px] text-sm"
          :class="{
            'border border-brand-headline font-medium': selected === size.value,
          }"
          @click="$emit('change', size.value)"
          >{{ size.value }}</BaseButton
        >
      </div>
    </div>
  </div>
</template>
